/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  DisableOpenRouterKeyRequestBody,
  DisableOpenRouterKeyRequestBody$Outbound,
  DisableOpenRouterKeyRequestBody$outboundSchema,
} from "../components/disableopenrouterkeyrequestbody.js";

export type DisableAdminOpenRouterKeySecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type DisableAdminOpenRouterKeyRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  disableOpenRouterKeyRequestBody: DisableOpenRouterKeyRequestBody;
};

/** @internal */
export type DisableAdminOpenRouterKeySecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DisableAdminOpenRouterKeySecurity$outboundSchema: z.ZodMiniType<
  DisableAdminOpenRouterKeySecurity$Outbound,
  DisableAdminOpenRouterKeySecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function disableAdminOpenRouterKeySecurityToJSON(
  disableAdminOpenRouterKeySecurity: DisableAdminOpenRouterKeySecurity,
): string {
  return JSON.stringify(
    DisableAdminOpenRouterKeySecurity$outboundSchema.parse(
      disableAdminOpenRouterKeySecurity,
    ),
  );
}

/** @internal */
export type DisableAdminOpenRouterKeyRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  DisableOpenRouterKeyRequestBody: DisableOpenRouterKeyRequestBody$Outbound;
};

/** @internal */
export const DisableAdminOpenRouterKeyRequest$outboundSchema: z.ZodMiniType<
  DisableAdminOpenRouterKeyRequest$Outbound,
  DisableAdminOpenRouterKeyRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    disableOpenRouterKeyRequestBody:
      DisableOpenRouterKeyRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      disableOpenRouterKeyRequestBody: "DisableOpenRouterKeyRequestBody",
    });
  }),
);

export function disableAdminOpenRouterKeyRequestToJSON(
  disableAdminOpenRouterKeyRequest: DisableAdminOpenRouterKeyRequest,
): string {
  return JSON.stringify(
    DisableAdminOpenRouterKeyRequest$outboundSchema.parse(
      disableAdminOpenRouterKeyRequest,
    ),
  );
}
